export const AuthErrorCode = {
  INVALID_CREDENTIALS: 'Wrong username/password.',
  TOKEN_EXPIRED: 'Token expired.',
  TOKEN_INCORECT: 'Incorrect token.',
  TOKEN_INVALID: 'Invalid authorization code.',
  NOT_AUTHENTICATED: 'Not authenticated.',
} as const;

export const CheckFilesErrorCode = {
  JOB_RUNNING: 'Data validation job is already running.',
} as const;
